import React, { Component } from "react";
import "./Topic.scss";
import SubTopicList from "../subTopicList/SubTopicList";
import { ReactComponent as AddIcon } from "../../../../../assets/svg/add-query.svg";
import { ReactComponent as SubIcon } from "../../../../../assets/svg/sub-query.svg";

export default class Topic extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expand: false,
        };
    }
    onCollapse() {
        this.setState({ expand: !this.state.expand });
    }
    componentDidMount() {
        if (this.props.packageObj?.package_code == "free") this.setState({ expand: true });
    }
    render() {
        return (
            <div key={this.props.ele.topic} className="table__row-main">
                <div className="topic__name-main" title="Topic">
                    <div className="topic__name-main-content">
                        <span className="add__icon">
                            {this.state.expand ? <SubIcon onClick={() => this.onCollapse()} /> : <AddIcon onClick={() => this.onCollapse()} />}
                        </span>
                        <span className="status__color" style={{ backgroundColor: this.props.ele.sub_topics[0].graph_color }}></span>
                        <span className="topic__name"> {this.props.ele.topic}</span>
                    </div>
                </div>
                {this.state.expand && (
                    <SubTopicList
                        ele={this.props.ele}
                        userTimeZone={this.props.userTimeZone}
                        expand={this.state.expand}
                        disableDataPull={this.props.disableDataPull}
                        enableDataPull={this.props.enableDataPull}
                        deleteSubtopicWithQuery={this.props.deleteSubtopicWithQuery}
                        handlEditQuery={this.props.handlEditQuery}
                        allLocations={this.props.allLocations}
                        handleDelete={this.props.handleDelete}
                        packageObj={this.props.packageObj}
                    />
                )}
            </div>
        );
    }
}
